import React, { useContext } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import Bmc from '../containers/bmc';
import Page404 from '../containers/Page404';
import ValueProposition from '../containers/valueProposition';
import CustomerSegment from '../containers/customerSegment';
import GetKeepGrow from '../containers/getKeepGrow';
import Channel from '../containers/channel';
import KeyActivity from '../containers/keyActivity';
import KeyPartners from '../containers/keyPartners';
import KeyResources from '../containers/keyResources';
import Sustainability from '../containers/sustainability';
import Portfolio from '../containers/portfolio';
import Account from '../containers/account/Account';
import Personal from '../containers/account/Personal';
import Password from '../containers/account/Password';
import Email from '../containers/account/Email';
import IdeationList from '../containers/ideation';
import IdeationItem from '../containers/ideation/IdeationItem';
import Testing from '../containers/testing';
import TestItem from '../containers/testing/Containers/TestItem';
import ScrollToTop from '../components/ScrollToTop';
import ActionCableHandler from '../containers/actioncable/ActionCableHandler';
import RouteRedirect from '../components/RouteRedirect';
import GlobalContext from './GlobalContext';
import * as AppRoute from './appRoutes';
import CostRevenue from '../containers/cost-revenue';

export const routes = {
  bmcs: {
    path: 'bmcs',
    children: {
      bmcId: {
        path: ':bmcId',
        children: {
          list: {
            path: 'list',
          },
          testing: {
            path: 'testing',
            children: {
              id: {
                path: 'id',
                children: {
                  intro: {
                    path: 'intro',
                  },
                  section: {
                    path: 'section',
                  },
                },
              },
            },
          },
          ideation: {
            path: 'ideation',
            children: {
              id: {
                path: 'id',
                children: {
                  intro: {
                    path: 'intro',
                  },
                  section: {
                    path: 'section',
                  },
                },
              },
            },
          },
          cost_revenue: {
            path: 'cost_revenue',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
          cost: {
            path: 'cost',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
          revenue: {
            path: 'revenue',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
          sustainability: {
            path: 'sustainability',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
          customer_segment: {
            path: 'customer_segment',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
          value_proposition: {
            path: 'value_proposition',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
          get_keep_grow: {
            path: 'get_keep_grow',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
          channel: {
            path: 'channel',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
          key_activity: {
            path: 'key_activity',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
          key_partners: {
            path: 'key_partners',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
          key_resources: {
            path: 'key_resources',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
          portfolio: {
            path: 'portfolio',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
          financial_files: {
            path: 'financial_files',
            children: {
              intro: {
                path: 'intro',
              },
            },
          },
        },
      },
    },
  },
  account: {
    path: 'account',
    children: {
      personal: {
        path: 'personal',
      },
      password: {
        path: 'password',
      },
      email: {
        path: 'email',
      },
    },
  },
};

const redirectToAvailableSection = (id, settings) => {
  if (settings.bmc) return AppRoute.bmc(id);
  if (settings.ideation) return AppRoute.ideation(id);
  if (settings.testing) return AppRoute.testing(id);
  if (settings.portfolio) return AppRoute.portfolio(id);
  return AppRoute.account();
};

export default function router() {
  const { bmcId, locales, sectionAvailabilitySettings } =
    useContext(GlobalContext);
  const { ideation, bmc, testing, portfolio } = sectionAvailabilitySettings;

  const bmcSections = [
    {
      section: routes.bmcs.children.bmcId.children.customer_segment.path,
      component: CustomerSegment,
    },
    {
      section: routes.bmcs.children.bmcId.children.value_proposition.path,
      component: ValueProposition,
    },
    {
      section: routes.bmcs.children.bmcId.children.get_keep_grow.path,
      component: GetKeepGrow,
    },
    {
      section: routes.bmcs.children.bmcId.children.channel.path,
      component: Channel,
    },
    {
      section: routes.bmcs.children.bmcId.children.key_activity.path,
      component: KeyActivity,
    },
    {
      section: routes.bmcs.children.bmcId.children.key_partners.path,
      component: KeyPartners,
    },
    {
      section: routes.bmcs.children.bmcId.children.key_resources.path,
      component: KeyResources,
    },
    // { section: 'cost', component: Cost },
    // { section: 'revenue', component: Revenue },
    {
      section: routes.bmcs.children.bmcId.children.sustainability.path,
      component: Sustainability,
    },
    {
      section: routes.bmcs.children.bmcId.children.cost_revenue.path,
      component: CostRevenue,
    },
  ];

  return (
    <Router>
      <ScrollToTop />
      <ActionCableHandler />
      <Switch>
        <Redirect
          exact
          from="/"
          to={redirectToAvailableSection(bmcId, sectionAvailabilitySettings)}
        />

        {bmc && (
          <Route exact path={`/${routes.bmcs.path}/:bmcId`}>
            <Bmc locales={locales} />
          </Route>
        )}

        {bmc && (
          <Route
            exact
            path={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.list.path}`}
          >
            <Bmc locales={locales} listMode />
          </Route>
        )}

        {testing && (
          <Route
            exact
            path={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.testing.path}`}
          >
            <Testing locales={locales} />
          </Route>
        )}

        {testing && (
          <Route
            exact
            path={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.testing.path}/:id`}
          >
            <RouteRedirect
              to={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.testing.path}/:id/${routes.bmcs.children.bmcId.children.testing.children.id.children.intro.path}`}
            />
          </Route>
        )}

        {testing && (
          <Route
            path={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.testing.path}/:id/:${routes.bmcs.children.bmcId.children.testing.children.id.children.section.path}`}
          >
            <TestItem locales={locales} />
          </Route>
        )}

        {ideation && (
          <Route
            exact
            path={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.ideation.path}`}
          >
            <IdeationList locales={locales} />
          </Route>
        )}

        {ideation && (
          <Route
            exact
            path={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.ideation.path}/:id`}
          >
            <RouteRedirect
              to={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.ideation.path}/:id/${routes.bmcs.children.bmcId.children.ideation.children.id.children.intro.path}`}
            />
          </Route>
        )}

        {ideation && (
          <Route
            path={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.ideation.path}/:id/:${routes.bmcs.children.bmcId.children.ideation.children.id.children.section.path}`}
          >
            <IdeationItem locales={locales} />
          </Route>
        )}

        {portfolio && (
          <Route
            path={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.portfolio.path}`}
          >
            <Portfolio locales={locales} />
          </Route>
        )}

        {/* Adding redirects for cost and revenue as they are now one unified section under cost_revenue */}
        {bmc && (
          <Route
            exact
            path={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.cost.path}`}
          >
            <RouteRedirect
              to={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.cost_revenue.path}/${routes.bmcs.children.bmcId.children.cost_revenue.children.intro.path}`}
            />
          </Route>
        )}

        {bmc && (
          <Route
            path={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.cost.path}/:rest(.*)`}
          >
            <RouteRedirect
              to={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.cost_revenue.path}/${routes.bmcs.children.bmcId.children.cost_revenue.children.intro.path}`}
            />
          </Route>
        )}

        {bmc && (
          <Route
            exact
            path={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.revenue.path}`}
          >
            <RouteRedirect
              to={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.cost_revenue.path}/${routes.bmcs.children.bmcId.children.cost_revenue.children.intro.path}`}
            />
          </Route>
        )}

        {bmc && (
          <Route
            path={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.revenue.path}/:rest(.*)`}
          >
            <RouteRedirect
              to={`/${routes.bmcs.path}/:bmcId/${routes.bmcs.children.bmcId.children.cost_revenue.path}/${routes.bmcs.children.bmcId.children.cost_revenue.children.intro.path}`}
            />
          </Route>
        )}

        {bmc &&
          bmcSections.map(({ section }) => (
            <Route
              exact
              path={`/${routes.bmcs.path}/:bmcId/${section}`}
              key={`${section}-intro`}
            >
              <RouteRedirect
                to={`/${routes.bmcs.path}/:bmcId/${section}/intro`}
              />
            </Route>
          ))}

        {bmc &&
          bmcSections.map(({ section, component }) => (
            <Route
              path={`/${routes.bmcs.path}/:bmcId/${section}/:section`}
              key={`${section}-section`}
            >
              {React.createElement(component, { locales })}
            </Route>
          ))}

        <Route exact path={`/${routes.account.path}`}>
          <Account locales={locales} />
        </Route>

        <Route
          path={`/${routes.account.path}/${routes.account.children.personal.path}`}
        >
          <Personal locales={locales} />
        </Route>

        <Route
          path={`/${routes.account.path}/${routes.account.children.password.path}`}
        >
          <Password locales={locales} />
        </Route>

        <Route
          path={`/${routes.account.path}/${routes.account.children.email.path}`}
        >
          <Email locales={locales} />
        </Route>

        <Route path="*" component={Page404} />
      </Switch>
    </Router>
  );
}
